const routes = [
  {
    index: true,
    label: 'Mustafa Ozkan',
    path: '/',
  },
  {
    labelKey: 'nav.about',
    label: 'About',
    path: '/about',
  },
  {
    labelKey: 'nav.resume',
    label: 'Resume',
    path: '/resume',
  },
  {
    labelKey: 'nav.projects',
    label: 'Projects',
    path: '/projects',
  },
  {
    labelKey: 'nav.contact',
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
